import {
  Pressable,
  StyleProp,
  Text,
  TextStyle,
  ViewStyle,
  StyleSheet,
  ImageStyle,
  View,
} from "react-native";
import { ms } from "./moderateScale";
import { Colors } from "@/constants";
import Icon, { IconType } from "./Icon";

export default function LargeButton({
  text,
  icon,
  emoji,
  onPress,
  iconContainerStyle,
  iconStyle,
  textStyle,
  hideRightIcon,
}: {
  text: string;
  icon?: IconType;
  emoji?: string;
  onPress: () => void;
  iconContainerStyle?: StyleProp<ViewStyle>;
  iconStyle?: StyleProp<ImageStyle>;
  textStyle?: StyleProp<TextStyle>;
  hideRightIcon?: boolean;
}) {
  return (
    <Pressable onPress={onPress} style={styles.button}>
      <View style={{ flexDirection: "row", alignItems: "center", gap: ms(12) }}>
        {icon && (
          <Icon
            icon={icon}
            containerStyle={StyleSheet.flatten([
              styles.iconContainer,
              iconContainerStyle,
            ])}
            style={StyleSheet.flatten([styles.icon, iconStyle])}
          />
        )}
        {emoji && (
          <View style={styles.iconContainer}>
            <Text style={{ fontSize: ms(16) }}>{emoji}</Text>
          </View>
        )}
        <Text style={StyleSheet.flatten([styles.text, textStyle])}>{text}</Text>
      </View>

      {!hideRightIcon && (
        <Icon
          icon="caretRight"
          style={{ tintColor: Colors.subtitle, width: ms(20), height: ms(20) }}
        />
      )}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
  },
  button: {
    width: "100%",
    flexDirection: "row",
    gap: ms(12),
    backgroundColor: Colors.white,
    height: ms(64),
    paddingHorizontal: ms(16),
    borderRadius: ms(12),
    alignItems: "center",
    justifyContent: "space-between",
  },
  iconContainer: {
    width: ms(40),
    height: ms(40),
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.text + "10",
    borderRadius: ms(40),
  },
  icon: {
    width: ms(16),
    height: ms(16),
  },
  text: {
    fontSize: ms(16),
    fontWeight: "500",
    color: Colors.text,
  },
});
